import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgUnderwriting = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("g", {
		transform: "translate(1.5652 0) scale(1.0435)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M19 9V6.5C19 4.29086 17.2091 2.5 15 2.5H5C2.79086 2.5 1 4.29086 1 6.5V17C1 19.2091 2.79086 21 5 21H7M6 1V4M14 8H6M12 12H6M8 16H6M14 1V4M10 21L13.0608 20.1274C13.2249 20.0806 13.3743 19.9928 13.495 19.8721L18.5098 14.8573C19.1634 14.2037 19.1634 13.1439 18.5098 12.4902C17.8561 11.8366 16.7963 11.8366 16.1427 12.4902L11.1279 17.505C11.0072 17.6257 10.9194 17.7751 10.8726 17.9392L10 21Z",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "round"
		})
	})]
});
const ForwardRef = forwardRef(SvgUnderwriting);
export default ForwardRef;
